import { Check, Loader2 } from 'lucide-react';

/**
 * Las tres tarjetas de tema, con su miniatura (portado de Payroll360 SaaS). La usan
 * Configuración → Apariencia (la cuenta elige el suyo) y la consola SuperAdmin (se le
 * cambia a una cuenta desde afuera, o a todas).
 */
const ESPECTRO = 'linear-gradient(90deg,#0E8889,#0E6BA2,#4C67A1,#D0493B,#F7B619,#6FBC55,#2CA297)';

export const TEMAS = [
  {
    id: 'finance360',
    nombre: 'Finance360 · marca de agua',
    detalle: 'Menú claro con el índigo de la marca como marca de agua y el logo a color.',
    // Mismos valores que estilos/agua.css
    lateral: {
      backgroundColor: '#fff',
      backgroundImage: 'radial-gradient(circle at 115% 92%, rgba(70,82,184,.2) 0 38px, transparent 39px),'
        + 'radial-gradient(circle at -35% 58%, rgba(44,51,128,.09) 0 30px, transparent 31px),'
        + 'linear-gradient(rgba(70,82,184,.05), rgba(70,82,184,.05))'
    },
    linea: 'rgba(44,51,128,.16)', activo: 'rgba(70,82,184,.2)', logo: '#4652B8',
    acento: '#4652B8', fondo: '#EFF1F7', regla: ESPECTRO
  },
  {
    id: 'finance360-solido',
    nombre: 'Finance360 · índigo sólido',
    detalle: 'Menú en índigo oscuro sólido con el logo para fondo oscuro.',
    lateral: { background: '#1A1D4E' },
    linea: 'rgba(255,255,255,.18)', activo: 'rgba(142,152,240,.35)', logo: '#FFFFFF',
    acento: '#4652B8', fondo: '#EFF1F7', regla: ESPECTRO
  },
  {
    id: 'clasico',
    nombre: 'Clásico',
    detalle: 'El aspecto de siempre: menú blanco con acentos azules.',
    lateral: { background: '#FFFFFF' },
    linea: '#E5E7EB', activo: '#DBEAFE', logo: '#2563EB',
    acento: '#2563EB', fondo: '#F9FAFB', regla: null
  }
];

// Miniatura del armazón: menú (como se ve en cada tema), cabecera y dos tarjetas
const Miniatura = ({ t }) => (
  <div className="rounded-lg overflow-hidden border border-gray-200 h-32 flex flex-col" style={{ background: t.fondo }}>
    {t.regla && <div style={{ height: 3, background: t.regla }} />}
    <div className="flex flex-1 min-h-0">
      <div className="w-1/4 p-2 space-y-1.5 border-r border-gray-200" style={t.lateral}>
        <div className="h-2 w-3/4 rounded mx-auto" style={{ background: t.logo }} />
        <div className="h-2 rounded" style={{ background: t.activo }} />
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-1.5 rounded" style={{ background: t.linea }} />
        ))}
      </div>
      <div className="flex-1 p-2 space-y-2">
        <div className="h-2.5 w-1/3 rounded bg-gray-300" />
        <div className="grid grid-cols-2 gap-2">
          <div className="h-10 rounded bg-white border border-gray-200" />
          <div className="h-10 rounded bg-white border border-gray-200" />
        </div>
        <div className="h-4 w-1/4 rounded border-2 bg-white" style={{ borderColor: t.acento }} />
      </div>
    </div>
  </div>
);

/**
 * @param tema        el tema en uso ('finance360' | 'finance360-solido' | 'clasico' | null)
 * @param guardando   id del tema que se está aplicando, o null
 * @param onElegir    (id) => void
 */
const SelectorDeTema = ({ tema, guardando, onElegir }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
    {TEMAS.map((t) => {
      const activo = tema === t.id;
      return (
        <button key={t.id} type="button" onClick={() => onElegir(t.id)} disabled={Boolean(guardando) || activo}
          className={`text-left bg-white rounded-xl border-2 p-4 transition-all disabled:cursor-default ${
            activo ? 'shadow-sm' : 'border-gray-200 hover:border-gray-300'}`}
          style={activo ? { borderColor: t.acento } : undefined}>
          <Miniatura t={t} />
          <div className="flex items-center justify-between mt-4">
            <span className="font-semibold text-gray-900">{t.nombre}</span>
            {activo ? (
              <span className="inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full border"
                style={{ color: t.acento, borderColor: t.acento }}>
                <Check className="w-3.5 h-3.5" /> En uso
              </span>
            ) : guardando === t.id ? (
              <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
            ) : (
              <span className="text-xs font-medium px-2.5 py-1 rounded-lg border border-gray-300 text-gray-700">Usar este</span>
            )}
          </div>
          <p className="text-sm text-gray-500 mt-1">{t.detalle}</p>
        </button>
      );
    })}
  </div>
);

export default SelectorDeTema;
